window.addEventListener('DOMContentLoaded', () => {
  menu_access()
});


/*
  Function name : menu_access
  Description : accessibility for the main menu
 */
const menu_access = () => {
  const nav_children = document.querySelectorAll('.navigation--children');

  [...nav_children].map(nav => {
    const menu_items = nav.querySelectorAll('a');
    const last_item = menu_items[menu_items.length-1];

    last_item.addEventListener('blur', () => { // on blur of the last element of a sub nav category
      const active_button = document.querySelector('[data-toggle].active');
      active_button.click(); // we close the sub nav category pane
    });
  });
}
